import {
	authInterceptorFactory,
	axios,
	interceptAndNormalizeResponse,
	piggyBack,
	requestHeaderNormalizerInterceptor
} from "@teaming/io-helpers";

const IO_TIMELINE_NAMESPACE = "timeline";

export default function ioTimelineFactory( { config: { baseUri }, authService, } ) {
	axios.defaults.baseURL = baseUri;
	axios.interceptors.request.use( requestHeaderNormalizerInterceptor );
	axios.interceptors.request.use( authInterceptorFactory( { authService, } ) );
	axios.interceptors.response.use( ...interceptAndNormalizeResponse() );

	return {
		namespace: IO_TIMELINE_NAMESPACE,
		fetchTimelineEvents: piggyBack( async ( teamId ) => {
			const result = await axios({
				method: 'get',
				url: `/timeline/${teamId}`
			});
			return result.data?.events || [];
		}),
		syncTimeline: async ( teamId ) => {
			const result = await axios({
				method: 'post',
				url: `/timeline/${teamId}/sync`
			});
			console.log('timeline synced', result);
			return result.data;
		},
		fetchTimelineEventDetails: piggyBack( async ( eventId ) => {
			const result = await axios({
				method: 'get',
				url: `/timeline/event/${eventId}`
			});
			return result.data;
		}),
		createTimelineEvent: piggyBack( async ( event ) => {
			const result = await axios({
				method: 'post',
				url: '/timeline',
				data: event
			});
			console.log('createTimelineEvent', result);
			return result.data;
		}),
	};
}
